import { useContext } from 'react';
import { SidePanelProviderMissingError } from '../../errors';
import { SidePanelSystemContext } from '../contexts/SidePanelSystemContext';

export function useInternalSidePanelSystem() {
    const store = useContext(SidePanelSystemContext);

    if (!store) {
        throw new SidePanelProviderMissingError();
    }

    return store;
}
